import { AprovacaoComercialComponent } from './_pages/aprovacao-comercial/aprovacao-comercial.component';
import { NgModule, Compiler, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AlertComponent } from './_directives';
import { AuthGuard } from './_guards';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AlertService, AuthenticationService, UserService } from './_services';
import { HomeComponent } from './_components/home/home.component';
import { ProtocoloComponent } from './_components/protocolo/protocolo.component';
import { TipoDocumentoComponent } from './_components/tipoDocumento/tipoDocumento.component';
import { SidebarComponent } from './_components/shared/sidebar/sidebar.component';
import { TextMaskModule } from 'angular2-text-mask';

import { RouterModule } from '@angular/router';

// Pages
import { LoginPageComponent } from './_pages/login-page/login-page.component';
import { HeaderComponent } from './_components/shared/header/header.component';
import { ProtocoloPageComponent } from './_pages/protocolo-page/protocolo-page.component';
import { ProtocoloNaoFiscalComponent } from './_pages/protocolo-nao-fiscal/protocolo-nao-fiscal.component';
import { HomePageComponent } from './_pages/home-page/home-page.component';
import { PanalCollapseComponent } from './_components/shared/panal-collapse/panal-collapse.component';
import { PopUpColetoresComponent } from './_components/popupColetores/popupColetores.component';
import { PopupMessagesComponent } from './_components/popup-messages/popup-messages.component';
import { PopupMessagesNewStyleTestComponent } from './_components/popup-messages-new-style-test/popup-messages-new-style-test.component';
import { ModalAvisosNfComponent } from './_components/modal-avisos-nf/modal-avisos-nf.component';
import { ConfirmacaoProtocoloComponent } from './_components/confirmacaoProtocolo/confirmacaoProtocolo.component';
import {
    ConfirmacaoProtocoloFundoFixoComponent
} from './_components/confirmacaoProtocoloFundoFixo/confirmacaoProtocoloFundoFixo.component';
import { ConfirmacaoDuplicidadeFiscalComponent } from './_components/confirmacaoDuplicidadeFiscal/confirmacaoDuplicidadeFiscal.component';
import { UploadComponent } from './_components/upload/upload.component';
import { UploadFiscalComponent } from './_components/upload-fiscal/upload-fiscal.component';
import { PopupAdiantamentosComponent } from './_components/popup-adiantamentos/popup-adiantamentos.component';
import { PopupTermoAdiantamentoComponent } from './_components/popup-termo-adiantamento/popup-termo-adiantamento.component';
import { PopupColetorCustosComponent } from './_components/popup-coletor-custos/popup-coletor-custos.component';
import { PopupFiltroPesquisaComponent } from './_components/popup-filtro-pesquisa/popup-filtro-pesquisa.component';
import { SettingsService } from './_services/settings.service';
import { UltimosProtocolosComponent } from './_components/ultimos-protocolos/ultimos-protocolos.component';
import { AcompanhamentoComponent } from './_components/acompanhamento/acompanhamento.component';
import { PlanilhaComponent } from './_components/planilha/planilha.component';
import { PlanilhaFiscalComponent } from './_components/planilha-fiscal/planilha-fiscal.component';
import { PlanilhaFundoFixoComponent } from './_components/planilha-fundo-fixo/planilha-fundo-fixo.component';
import { MaskService } from './_services/mask.service';
import { AdiantamentoComponent } from './_components/adiantamento/adiantamento.component';
import { FundoFixoComponent } from './_components/fundo-fixo/fundo-fixo.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { AusenciaTemporariaPageComponent } from './_pages/ausencia-temporaria-page/ausencia-temporaria-page.component';
import { AcompanhamentoPageComponent } from './_pages/acompanhamento-page/acompanhamento-page.component';
import { AusenciaTemporariaComponent } from './_components/ausencia-temporaria/ausencia-temporaria.component';
import { PageNotFoundComponent } from './_pages/page-not-found/page-not-found.component';
import { ListaCentroCustosComponent } from './_components/lista-centro-custos/lista-centro-custos.component';
import { ListaDiagramaRedeComponent } from './_components/lista-diagrama-rede/lista-diagrama-rede.component';
import { ListaOrdemInternaComponent } from './_components/lista-ordem-interna/lista-ordem-interna.component';
import { AppRoutingModule } from './app.routing';
import { ProtocoloFiscalComponent } from './_pages/protocolo-fiscal/protocolo-fiscal.component';
import { PopupCentroLogisticoComponent } from './_components/popup-centro-logistico/popup-centro-logistico.component';
import { PopupProdutosComponent } from './_components/popup-produtos/popup-produtos.component';
import { RastrearProtocoloComponent } from './_components/rastrear-protocolo/rastrear-protocolo.component';
import { RastrearProtocoloPageComponent } from './_pages/rastrear-protocolo-page/rastrear-protocolo-page.component';
import { MglTimelineModule } from 'angular-mgl-timeline';
import { CleanInputOnfocusDirective } from './_directives/clean-input-onfocus.directive';
import { ProdutoModalComponent } from './_components/produto-modal/produto-modal.component';
import { ProdutoModalService } from './_services/produto-modal.service';
import { SnackBarService } from './_services/snackBar.service';
import { OnlyNumbersDirective } from './_directives/only-numbers.directive';
import { AuthGuardSpecial } from './_guards/auth.guard.special';
import { StatusProtocoloFiscalModalComponent } from './_components/status-protocolo-fiscal-modal/status-protocolo-fiscal-modal';
import {
    ProtocolosPendetesAprovacaoComercialComponent
} from './_components/protocolos-pendetes-aprovacao-comercial/protocolos-pendetes-aprovacao-comercial.component';
import { MatSelectFilterModule } from 'mat-select-filter';;
import { OnlyNumberWithDecimalDirective } from './_directives/only-number-with-decimal.directive'
import { MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { Ad } from './_helpers/ad.config';
import { AppEnvironment } from './_helpers/enviroment.util';
import { Traducao } from './_helpers/traducao.util';
import { FooterComponent } from './_components/shared/footer/footer.component';

const materialModules = [
    MatExpansionModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatTableModule,
    MatTableExporterModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatRadioModule,
    MatSnackBarModule
];

registerLocaleData(localePt);

@NgModule({
    imports: [
        MsalModule.forRoot(Ad.MSALConfigFactory(),Ad.MSALAngularGuardConfigFactory(),Ad.MSALAngularInterceptorConfigFactory()),
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        RouterModule,
        materialModules,
        FlexLayoutModule,
        BrowserAnimationsModule,
        TextMaskModule,
        CurrencyMaskModule,
        MglTimelineModule,
        MatSelectFilterModule,
        MatListModule
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,
        ProtocoloComponent,
        TipoDocumentoComponent,
        SidebarComponent,
        LoginPageComponent,
        HeaderComponent,
        ProtocoloPageComponent,
        ProtocoloNaoFiscalComponent,
        HomePageComponent,
        PanalCollapseComponent,
        PopUpColetoresComponent,
        PopupMessagesComponent,
        PopupMessagesNewStyleTestComponent,
        ModalAvisosNfComponent,
        ConfirmacaoProtocoloComponent,
        ConfirmacaoProtocoloFundoFixoComponent,
        ConfirmacaoDuplicidadeFiscalComponent,
        UploadComponent,
        UploadFiscalComponent,
        PopupAdiantamentosComponent,
        PopupTermoAdiantamentoComponent,
        PopupColetorCustosComponent,
        PopupFiltroPesquisaComponent,
        PopupCentroLogisticoComponent,
        UltimosProtocolosComponent,
        AcompanhamentoComponent,
        PlanilhaComponent,
        PlanilhaFiscalComponent,
        PlanilhaFundoFixoComponent,
        AdiantamentoComponent,
        FundoFixoComponent,
        AusenciaTemporariaPageComponent,
        AcompanhamentoPageComponent,
        AusenciaTemporariaComponent,
        PageNotFoundComponent,
        ListaCentroCustosComponent,
        ListaDiagramaRedeComponent,
        ListaOrdemInternaComponent,
        ProtocoloFiscalComponent,
        PopupProdutosComponent,
        RastrearProtocoloPageComponent,
        RastrearProtocoloComponent,
        CleanInputOnfocusDirective,
        ProdutoModalComponent,
        OnlyNumbersDirective,
        StatusProtocoloFiscalModalComponent,
        AprovacaoComercialComponent,
        ProtocolosPendetesAprovacaoComercialComponent,
        OnlyNumberWithDecimalDirective,
        FooterComponent
    ],
    entryComponents: [
        ProdutoModalComponent,
        StatusProtocoloFiscalModalComponent
    ],
    providers: [
        { provide: Compiler, useValue: undefined },
        { provide: APP_INITIALIZER, useFactory: init, deps: [HttpClient], multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MatPaginatorIntl, useValue: Traducao.paginacao() },
        { provide: LocationStrategy, useClass: PathLocationStrategy},
        AuthGuard,
        AuthGuardSpecial,
        AlertService,
        DatePipe,
        AuthenticationService,
        UserService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
        SettingsService,
        MaskService,
        ProdutoModalService,
        SnackBarService,
        MsalService
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]

})

export class AppModule { }

export function init(httpClient: HttpClient) {
    return async () => {
     const response = await httpClient.get<any>('assets/client-config.json').toPromise();
     AppEnvironment.set(response);
    }
}